module.exports = __webpack_public_path__ + "img/MES10Indice2.c61a663f.png";